import TvanHandleApi from 'api/TvanHandleApi'
import ModalConfirm from 'general/components/Modal/ModalConfirm'
import ToastHelper from 'general/helpers/ToastHelper'
import { memo, useCallback, useEffect, useRef, useState } from 'react'
import { useFormik } from 'formik'
import DraggableModal from 'general/components/Modal/DragableModal/DraggableModal'
import { Typography } from 'antd'
import CustomAntInput from 'general/components/Forms/CustomAntInput/CustomAntInput'
import * as Yup from 'yup'
import { REGEX_TVAN_MESSAGE } from 'general/constants/AppRegex'
import CustomLabel from 'general/components/CustomLabel'
import CustomSelect from 'general/components/CustomSelect'
import SelectOptions from 'general/constants/SelectOptions'
import { FormLabel } from 'react-bootstrap'
import TextArea from 'antd/es/input/TextArea'
const ModalUpdateSendTaxStatus = ({
  modalsState,
  setModalsState,
  refetchList,
}) => {
  const [dataConfix, setDataConfix] = useState(modalsState?.data)

  useEffect(() => {
    if (modalsState?.show) {
      setDataConfix(modalsState?.data)
    } else {
      setDataConfix({})
    }
  }, [modalsState?.show])

  const update = async (dataConfix) => {
    // Your logic to move to send invoice goes here
    // For example, you can call an API endpoint to move to send invoice
    // await sendInvoiceToHandler(payload)
    console.log('dataConfix', dataConfix)
    let check = false
    if (!dataConfix?.reason) {
      ToastHelper.showError('Vui nhập lý do thay đổi hóa đơn')
      check = true
    }
    if (check) return
    try {
      const { result, message } =
        await TvanHandleApi.updateSendTaxStatusInvoiceSendQueue({
          invoiceIds: [dataConfix?.invoiceId],
          reason: dataConfix?.reason,
        })
      if (result === 'success') {
        ToastHelper.showSuccess('Cập nhật hóa đơn thành công')

        refetchList()
        setModalsState({ show: false, data: {} })
      } else {
        ToastHelper.error('Lỗi nội bộ máy chủ')
      }
    } catch (error) {
      console.error('Occured error at update function: ' + error)
    }
  }
  console.log('modalsState', modalsState)

  return (
    <>
      <ModalConfirm
        header="Cập nhật trạng thái hóa đơn và gửi message Queue cho đối tác"
        submitNotClose={1}
        content={
          <>
            <div className="flex-row">
              <div>
                <FormLabel fontWeight="600">
                  Lý do <span className="text-danger">(*)</span>
                </FormLabel>
              </div>
              <div>
                <TextArea
                  value={dataConfix?.reason}
                  showCount
                  maxLength={300}
                  onChange={(e) => {
                    setDataConfix({
                      ...dataConfix,
                      reason: e?.target?.value,
                    })
                  }}
                  placeholder="Nhập lý do không vượt quá 300 ký tự"
                  style={{ height: 120, resize: 'none' }}
                />
              </div>
            </div>
          </>
        }
        show={modalsState.show}
        setShow={(status) => setModalsState({ ...modalsState, show: status })}
        handleConfirm={(e) => {
          update(dataConfix)
          // e.preventDefault()
          // moveToSendErrorHandler({ invoiceId: tvanState.activeRow?.invoiceId })
          // setModalsState({ key: 'moveStatusModal', value: false })
        }}
      />
    </>
  )
}
export default memo(ModalUpdateSendTaxStatus)
